<script setup lang="ts">
/**
 * Modale Recherche globale : ouvre l'arbre GLOBAL du joueur-univers en overlay
 * (overlays.store) au lieu d'une navigation pleine page. La route
 * /research/global reste un deep-link.
 */
import { computed } from 'vue';
import { useOverlaysStore } from '@/stores/overlays.store';
import ResearchGlobalView from '@/views/game/ResearchGlobalView.vue';

const overlays = useOverlaysStore();
const open = computed({
  get: () => overlays.researchGlobalOpen,
  set: (v: boolean) => { overlays.researchGlobalOpen = v; },
});
</script>

<template>
  <el-dialog
    v-model="open"
    title="🔬 Recherches"
    width="min(96vw, 1280px)"
    append-to-body
    destroy-on-close
    align-center
    class="overlay-dialog"
  >
    <ResearchGlobalView v-if="open" />
  </el-dialog>
</template>

<style scoped lang="scss">
.overlay-dialog :deep(.el-dialog__body) {
  max-height: 82vh;
  overflow-y: auto;
  padding-top: 0;
}
</style>
